import type React from "react";
import type { FC } from "react";
import { Box, Button } from "@mui/material";
import { EventPostback } from "@fas/cpa-cabinet-ui";
import type { EventPostbackType } from "@fas/cpa-cabinet-ui/lib/EventPostback/EventPostback.types";

export const eventTypeOptions = [
  {
    title: "Info",
    value: "info",
  },
  {
    title: "Negative",
    value: "negative",
  },
];

export const eventNameOptions = {
  info: [
    {
      title: "Registration",
      value: "registration",
    },
    {
      title: "Confirm",
      value: "confirm",
    },
    {
      title: "Payment",
      value: "payment",
    },
    {
      title: "Try",
      value: "try",
    },
  ],
  negative: [
    {
      title: "Chargeback",
      value: "chargeback",
    },
    {
      title: "Decline",
      value: "decline",
    },
  ],
};

type Props = {
  items: Array<EventPostbackType>,
  onChange: (items: Array<EventPostbackType>) => void,
}

const EventPostbackComponent: FC<Props> = ({
  items,
  onChange,
}: Props) => {
  const someEdited = items.some(({ isEditable }) => isEditable);
  const handleUpdateEventsPostback = (index: number, item: EventPostbackType) => {
    const newItem = (items[index]?.type !== item.type) ? { ...item, name: "" } : item;
    onChange([...items.slice(0, index), newItem, ...items.slice(index + 1)]);
  };

  const handleAddEventsPostback = (item: EventPostbackType) => {
    onChange([...items, item]);
  };

  const handleSaveEventPostback = (index: number, item: EventPostbackType) => {
    onChange([...items.slice(0, index), item, ...items.slice(index + 1)]);
  };

  const handleDeleteEventPostback = (index: number) => {
    onChange([...items.slice(0, index), ...items.slice(index + 1)]);
  };
  return (
    <Box>
      {items.map((postback: EventPostbackType, index: number) => (
        <EventPostback
          key={postback.id}
          data={postback}
          onChange={(item: EventPostbackType): void => handleUpdateEventsPostback(index, item)}
          onSave={(item: EventPostbackType): void => handleSaveEventPostback(index, item)}
          onDelete={(): void => handleDeleteEventPostback(index)}
          disabled={someEdited}
          typeOptions={eventTypeOptions}
          nameOptions={eventNameOptions[postback.type as "info" | "negative"] || []}
          classes={{ button: "MuiButton-contained MuiButton-containedPrimary" }}
        />
      ))}

      { items.length < 5 && (
        <Box pt={2}>
          <Button
            disabled={someEdited}
            variant="contained"
            onClick={() => handleAddEventsPostback({
              id: Math.random().toString(16).slice(2),
              name: "",
              type: "",
              url: "",
              isEditable: true,
            })}
            data-testid="event-postback-add-button"
          >
            Add events postback
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default EventPostbackComponent;
